export default "__VITE_ASSET__BXrXWPYB__"